import {
  Component,
  ChangeDetectionStrategy,
  input,
  computed,
} from '@angular/core';
import { Ag1LoaderComponent } from '../ag1-loader/ag1-loader.component';

/**
 * @deprecated Do not add new instances of this component. Use PrimeNG's 'p-avatar' instead.
 * @description A component that displays an avatar image or initial
 */
@Component({
  selector: 'ag1-avatar',
  templateUrl: './ag1-avatar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Ag1LoaderComponent],
})
export class Ag1AvatarComponent {
  // input signals
  readonly avatarUrl = input<string | null>(null);
  readonly label = input<string | null>(null);
  readonly isLoading = input<boolean>(false);

  // computed signals
  readonly initial = computed(() => this.label()?.[0] || 'A');
}
